import { cx } from '@linaria/core';
import { useActiveRevision } from '@pm2/course-revisions';
import { Link } from '@provider/navigation';
import { CSSRefTransition, PostloadedImage } from '@utils/react';
import { badgeTransitionDurationMs, revisionBadge, headingCls, linkCls, modifiers, vignetteCls, vignetteAspectRatioCls, img } from './nav-header.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const Header = ({
  pageDescriptor
}) => {
  const heading = pageDescriptor.title;
  const activeRevision = useActiveRevision(pageDescriptor.id);
  const isLongTitle = heading.length > 26;
  return /*#__PURE__*/jsx("h3", {
    children: /*#__PURE__*/jsxs(Link, {
      className: cx(linkCls, isLongTitle && modifiers.longTitle.className),
      href: pageDescriptor.path,
      children: [/*#__PURE__*/jsx(CSSRefTransition, {
        in: !!activeRevision,
        classNames: revisionBadge,
        timeout: badgeTransitionDurationMs,
        mountOnEnter: true,
        unmountOnExit: true,
        children: ref => /*#__PURE__*/jsx("span", {
          ref: ref,
          className: cx(revisionBadge, pageDescriptor.vignette && "withVignette"),
          children: "Version"
        })
      }), pageDescriptor.vignette && /*#__PURE__*/jsx(Vignette, {
        vignette: pageDescriptor.vignette
      }), /*#__PURE__*/jsx("span", {
        className: cx(headingCls, pageDescriptor.vignette && "vignette"),
        children: heading
      })]
    })
  });
};
const Vignette = ({
  vignette
}) => {
  return /*#__PURE__*/jsx("div", {
    className: vignetteCls,
    children: /*#__PURE__*/jsx("div", {
      className: vignetteAspectRatioCls,
      children: /*#__PURE__*/jsx(PostloadedImage, {
        className: img,
        src: vignette.url,
        sizes: "90px",
        alt: ""
      })
    })
  });
};

export { Header };
//# sourceMappingURL=nav-header.js.map
